(() => {
  const initializeReadings = (scope = document) => {
    scope.querySelectorAll('[data-focus-form]').forEach(link => {
      if (link.dataset.readingBound) return;
      link.dataset.readingBound = 'true';
      link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        target?.focus({ preventScroll: true });
      });
    });
    scope.querySelectorAll('[data-reading-photo]').forEach(input => {
      if (input.dataset.readingBound) return;
      input.dataset.readingBound = 'true';
      input.addEventListener('change', () => {
        const file = input.files?.[0];
        const allowed = ['image/jpeg', 'image/png', 'image/webp'];
        input.setCustomValidity(file && (!allowed.includes(file.type) || file.size > 10 * 1024 * 1024) ? 'Please choose a JPG, PNG or WebP image no larger than 10 MB.' : '');
        if (!input.validity.valid) input.reportValidity();
      });
    });
    scope.querySelectorAll('[data-bundle-form]').forEach(form => {
      if (form.dataset.readingBound) return;
      form.dataset.readingBound = 'true';
      const button = form.querySelector('[data-bundle-submit]');
      const message = form.querySelector('[data-bundle-message]');
      const card = form.closest('[data-bundle-card]');
      const items = [...form.querySelectorAll('[data-bundle-item]')];
      const money = new Intl.NumberFormat(form.dataset.locale || 'en-GB', { style: 'currency', currency: form.dataset.currency || 'GBP' });
      const updatePrice = () => {
        const prices = items.map(item => Number(item.querySelector('[data-bundle-variant]').selectedOptions[0].dataset.price));
        const total = prices.reduce((sum, price) => sum + price, 0);
        const discounted = prices.reduce((sum, price) => sum + price - Math.floor(price / 10), 0);
        const price = card.querySelector('[data-bundle-price]');
        price.querySelector('strong').textContent = money.format(discounted / 100) + ' ' + form.dataset.currency;
        price.querySelector('s').replaceChildren();
        const label = document.createElement('span'); label.className = 'sr-only'; label.textContent = 'Bought separately: ';
        price.querySelector('s').append(label, money.format(total / 100));
        card.querySelector('[data-bundle-saving]').textContent = 'Save ' + money.format((total - discounted) / 100) + ' on the current individual prices';
      };
      form.querySelectorAll('[data-bundle-variant]').forEach(select => select.addEventListener('change', updatePrice));
      button.disabled = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
        form.dataset.submitting = 'true';
        button.disabled = true; button.textContent = 'Adding your three readings…';
        message.hidden = true;
        const value = name => form.elements.namedItem(name)?.value.trim() || '';
        const requestId = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
        const payload = items.map(item => {
          const properties = { Name: value('reading_name'), 'Your question': item.querySelector('[data-bundle-question]').value.trim(), Collection: form.dataset.bundleName, _bundle_request: requestId };
          if (['birth-chart-reading', 'numerology-life-path-reading'].includes(item.dataset.handle)) properties['Date of birth'] = value('birth_date');
          if (item.dataset.handle === 'birth-chart-reading') {
            properties.Birthplace = value('birth_place');
            if (value('birth_time')) properties['Birth time'] = value('birth_time');
          }
          return { id: Number(item.querySelector('[data-bundle-variant]').value), quantity: 1, properties };
        });
        try {
          // One request adds all three, preserving separate personalisation on each order line.
          const response = await fetch(form.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: payload }) });
          const result = await response.json();
          if (!response.ok || !Array.isArray(result.items) || result.items.length !== 3) throw new Error('Basket update needs review.');
          window.location.assign(form.dataset.cartUrl);
        } catch {
          // A lost response can still mean the basket changed. Never automatically retry an add.
          message.replaceChildren(document.createTextNode('We could not confirm that all three readings were added. Please check your basket before trying again, so nothing is added twice. '));
          const link = document.createElement('a'); link.href = form.dataset.cartUrl; link.textContent = 'Check my basket'; message.append(link);
          message.hidden = false; message.focus(); button.textContent = 'Please check your basket';
        }
      });
    });
  };
  initializeReadings();
  document.addEventListener('shopify:section:load', event => initializeReadings(event.target));
})();
